import React from 'react';

const SimpleNotification = ({ message }) => {
    if (!message) return null;

    return (
        <div
            style={{
                position: 'fixed',
                left: '50%',
                bottom: 24,
                transform: 'translateX(-50%)',
                zIndex: 9999,
            }}
        >
            <div
                style={{
                    padding: '10px 16px',
                    borderRadius: '8px',
                    backgroundColor: '#FFFFFF',
                    boxShadow: '0 4px 10px rgba(15,23,42,0.12)',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 10,
                    fontSize: 13,
                    color: '#111827',
                }}
            >
                <div
                    style={{
                        width: 18,
                        height: 18,
                        borderRadius: '8px',
                        backgroundColor: '#111827',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#FFFFFF',
                        fontSize: 11,
                        flexShrink: 0,
                    }}
                >
                    ✓
                </div>
                <span>{message}</span>
            </div>
        </div>
    );
};

export default SimpleNotification;






